<template>
  <div>
    <base-card :loading="loading" class="rounded-lg pb-2">
      <div
        class="d-flex justify-center text--disabled align-center gap-1 pt-1 unselectable"
      >
        <small class="lh-1">
          {{ party?.name || "Carregando..." }}
        </small>
      </div>
      <v-tabs v-model="tab" show-arrows class="rounded-lg" height="36px">
        <v-tab
          v-for="tab in loading ? [] : tabsFiltered"
          class="rounded-lg"
          :key="tab.component"
        >
          <v-icon left small>{{ tab.icon }}</v-icon>
          {{ tab.name }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" :touchless="tabsFiltered[tab]?.touchless">
        <v-tab-item
          v-for="item in loading ? [] : tabsFiltered"
          :key="item.name"
          class="pa-4"
        >
          <component :is="item.component" :party="party" @refresh="getParty" />
        </v-tab-item>
      </v-tabs-items>
    </base-card>

    <!-- Navgation  -->
    <v-bottom-sheet
      v-model="navigationSheet"
      inset
      max-width="550px"
      :overlay-opacity="0.8"
      content-class="elevation-0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          style="position: fixed; bottom: 76px; right: 16px; z-index: 5"
          float
          v-bind="attrs"
          v-on="on"
          color="primary"
        >
          <v-icon> mdi-dots-grid </v-icon>
        </v-btn>
      </template>
      <div class="mb-4 px-4 d-flex w-full">
        <v-card class="pa-3 pb-1 rounded-lg w-full">
          <v-row dense class="mx-0">
            <v-col
              v-for="tab in tabsFiltered"
              :key="tab?.id"
              cols="4"
              sm="4"
              md="3"
            >
              <v-card
                @click="selectTab(tab?.id)"
                outlined
                height="90px"
                elevation="0"
                class="pa-2"
              >
                <div
                  class="d-flex align-center justify-center flex-column h-full text-center lh-1 gap-2"
                >
                  <v-icon>{{ tab.icon }}</v-icon>
                  {{ tab.name }}
                </div>
              </v-card>
            </v-col>
          </v-row>
          <div class="d-flex justify-center">
            <v-btn @click="navigationSheet = false" text small> Fechar </v-btn>
          </div>
        </v-card>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PARTY from "@/services/admin/parties";
import PartySecurity from "../../components/admin/party/PartySecurity.vue";
import PartyPayments from "../../components/admin/party/PartyPayments.vue";
import PartyTechnicians from "../../components/admin/party/PartyTechnicians.vue";
import PartyTickets from "../../components/admin/party/PartyTickets.vue";
import PartyResourceRequests from "../../components/admin/party/PartyResourceRequests.vue";
import PartyTecnicianDaily from "../../components/admin/party/PartyTecnicianDaily.vue";
import PartyWithdraws from "../../components/admin/party/PartyWithdraws.vue";

export default {
  metaInfo() {
    return { title: `⚙️ ${this.party?.name || "Carregando..."}` };
  },
  data: () => ({
    loading: true,
    party: null,
    tab: null,
    navigationSheet: false,
    tabs: [
      {
        id: "security",
        name: "Segurança",
        component: "PartySecurity",
        permission: 4096,
        icon: "mdi-security",
        touchless: true,
      },
      {
        id: "technicians",
        name: "Técnicos",
        component: "PartyTechnicians",
        permission: 4096 + 2,
        icon: "mdi-account-wrench",
        touchless: false,
      },
      {
        id: "withdrawals",
        name: "Repasses",
        component: "PartyWithdraws",
        permission: 4096 + 33554432,
        icon: "mdi-bank-transfer",
        touchless: false,
      },
      {
        id: "resource-requests",
        name: "Solicitações de Recursos",
        component: "PartyResourceRequests",
        permission: 4096 + 16777216,
        icon: "mdi-message",
        touchless: false,
      },
      {
        id: "technical-diary",
        name: "Diário Técnico",
        component: "PartyTecnicianDaily",
        permission: 4096,
        icon: "mdi-notebook",
        touchless: false,
      },
      {
        id: "payments",
        name: "Pagamentos",
        component: "PartyPayments",
        permission: 4096 + 131072,
        icon: "mdi-cash-multiple",
        touchless: false,
      },
      {
        id: "tickets",
        name: "Ingressos",
        component: "PartyTickets",
        permission: 4096 + 131072,
        icon: "mdi-ticket",
        touchless: false,
      },
    ],
  }),
  methods: {
    async getParty() {
      try {
        this.loading = true;
        var response = await PARTY.getById(this.$route.params.id);
        this.party = response.party;
        this.loading = false;
        this.tab = 0;
        this.selectTab();
        this.$root.$emit("setImgBg", this.party?.cover);
      } catch (error) {
        this.$router.push({ name: "admin.parties" });
      }
    },
    selectTab(tab) {
      if (tab) window.location.replace("#" + tab);
      if (this.$route.hash) {
        let hash = tab || this.$route.hash.replace("#", "");
        let index = this.tabsFiltered.findIndex((tab) => tab?.id == hash);
        if (index >= 0) this.tab = index;
        this.navigationSheet = false;
      }
    },
    vibrate() {
      if (navigator.vibrate) navigator.vibrate(50);
    },
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    ...mapGetters("auth", ["hasPermission"]),
    tabsFiltered() {
      return this.tabs.filter(
        (tab) => !tab.permission || this.hasPermission(tab.permission)
      );
    },
  },
  watch: {
    tab: {
      handler(val, oldVal) {
        if (val !== null && oldVal !== null) this.vibrate();
        let tab = this.tabsFiltered[val];
        if (tab) window.location.replace("#" + tab?.id);
      },
      immediate: true,
    },
    "$route.hash"() {
      this.selectTab();
    },
    "$route.params.partyId"() {
      this.getParty();
    },
    "selectedCompany.id"() {
      this.$router.push({
        name: "admin.parties",
      });
    },
  },
  components: {
    PartyTickets,
    PartySecurity,
    PartyPayments,
    PartyWithdraws,
    PartyTechnicians,
    PartyResourceRequests,
    PartyTecnicianDaily,
  },
  destroyed() {
    this.$root.$emit("setImgBg", null);
  },
  mounted() {
    this.getParty();
  },
};
</script>

<style></style>
